import React from "react";
import {
  Box,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IPriceItinerary } from "../interfaces.lowPrice";
import {
  dateObjToDayDateStringShort,
  dateObjToMonthShortDate,
  dateObjToWeekday,
  useConfig,
} from "@thekilroygroup/shared-ui";

interface IProps {
  priceItinerary: IPriceItinerary;
  height: number;
  width: number;
  sxProps?: SxProps;
}

export const DepartureDate = (props: IProps) => {
  const { priceItinerary, height, width, sxProps } = props;
  const { locale } = useConfig();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        height: theme.spacing(height),
        left: `${(priceItinerary.departureDateDifference + 2) * width}%`,
        ...sxProps,
      }}
    >
      {isMobile ? (
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            width: "100%",
          }}
        >
          <Typography variant="titleExtraSmall">
            {dateObjToDayDateStringShort(
              new Date(priceItinerary.departureDate),
              locale,
            )}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            display: "flex",
            width: "100%",
            padding: 1.5,
          }}
        >
          <Typography variant="titleMedium" weight="bold">
            {dateObjToMonthShortDate(
              new Date(priceItinerary.departureDate),
              locale,
            )}
          </Typography>
          <Typography variant="titleExtraSmall">
            {dateObjToWeekday(new Date(priceItinerary.departureDate), locale)}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
